
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as appleTUgdupPYETEsFts5sUBdB7DuhgYh5Kp6jsVwYhU5IUYMeta } from "/src/app/pages/authentification/callback/client/apple.vue?macro=true";
import { default as facebookZz0eQjO3HonO2Tm0CxfCbt4TdrXhU2iGsSk6m6fYoXgMeta } from "/src/app/pages/authentification/callback/facebook.vue?macro=true";
import { default as googleLMy713whuqFzMMtiJNj_xm0_nOq0Kwpdz23ZncRAD0YMeta } from "/src/app/pages/authentification/callback/google.vue?macro=true";
import { default as corbeilleqDOpTGeIcKtfZdtuQPPccNTF_avuLepmujmzRAHgbo8Meta } from "/src/app/pages/compte/messagerie/corbeille.vue?macro=true";
import { default as avatarPoGO5IMe5K1Lqrxnf8eS7d3y4L1MTEuKCjRcEPz7LBIMeta } from "/src/app/pages/compte/parametres/avatar.vue?macro=true";
import { default as connexionSlThuxhKy2zWvotEPs_ZQ1YaZdp5p4zzuTt6_hosM9wMeta } from "/src/app/pages/compte/parametres/connexion.vue?macro=true";
import { default as emailbAFQJH7XqLZX_DGDoOfIBf_NfafvbvEiDNv4KAnWfkQMeta } from "/src/app/pages/compte/parametres/email.vue?macro=true";
import { default as mot_45de_45passeSvv0t73zZhQeBR6fzu_WzPHS9IM7wyhlG6SfLqFjRuQMeta } from "/src/app/pages/compte/parametres/mot-de-passe.vue?macro=true";
import { default as nom_45utilisateurVLGbCSEncaoXP3lL4hfpGOB6ZoXHNbmyx9930tpmeVgMeta } from "/src/app/pages/compte/parametres/nom-utilisateur.vue?macro=true";
import { default as notificationGigBvfqLO6izcOLID3YS0zSlnlDc085x0O1gYpz0jaoMeta } from "/src/app/pages/compte/parametres/notification.vue?macro=true";
import { default as phoneelsAZlNW4DBzI9VSfESuZYsj723JjQgcBHrn_f0AncMMeta } from "/src/app/pages/compte/parametres/phone.vue?macro=true";
import { default as _91uuidOrder_93xBqOeeb7ayprc_Ftup4M4UBwMmgrX756LXuh_E572ygMeta } from "/src/app/pages/compte/commandes/[uuidOrder].vue?macro=true";
import { default as _91idTopic_93utjlutkWFk1xon_VyNqO_kmPAWdQk2WO6SCIvzr_23EMeta } from "/src/app/pages/compte/messagerie/[idTopic].vue?macro=true";
import { default as chargementPt5B9ASD36xNeTyjylr37lGQYA5rwPQi_6SWXHTd6MkMeta } from "/src/app/pages/authentification/chargement.vue?macro=true";
import { default as index0_HPY7LS06aVrMevTTBUit0udSdwLO3iLLXCoBlHe4cMeta } from "/src/app/pages/compte/commandes/index.vue?macro=true";
import { default as index36IqjPZfI_E6VW8S1lvy_WUYOZPT5wl_m_NBfx22TRcMeta } from "/src/app/pages/compte/messagerie/index.vue?macro=true";
import { default as indexiqr3a13JhNR6O_KZZAeZFXyyJj4gHl3MeMdPlUCRoVUMeta } from "/src/app/pages/compte/parametres/index.vue?macro=true";
import { default as supprimerZ6E7U8G3nCdAyzxWBl7H3JJQ36vUUr9L0M6_TMuu9OcMeta } from "/src/app/pages/compte/supprimer.vue?macro=true";
import { default as actifsGihZ8OH8irkaoTyhgiqaFrPf566Xz2c50PyN6MyHBh8Meta } from "/src/app/pages/mes-evenements/actifs.vue?macro=true";
import { default as archivesaHy5hpyMA3OyuYtcgNtzXvOB_KAaSH_P3HxfiSCNKtcMeta } from "/src/app/pages/mes-evenements/archives.vue?macro=true";
import { default as planningNOzjQb_D5xaM9Vt_RtECsPq_pTZEgQK_UZkDYidKJyQMeta } from "/src/app/pages/mes-evenements/planning.vue?macro=true";
import { default as a_45utiliserWONaayWYJTa6VkGkybTuJsWFLkfIAtAOymQ8DerD0CUMeta } from "/src/app/pages/mises-en-avant/a-utiliser.vue?macro=true";
import { default as en_45attenteFhB1rzzvsHK1GCKepLAztC6XYcoN3qJTxRz_7sef5C8Meta } from "/src/app/pages/mises-en-avant/en-attente.vue?macro=true";
import { default as pack0BIEtafZKsi6fx4rc1HupLvN_nulcf7XJHOAf_fkQmEMeta } from "/src/app/pages/mises-en-avant/pack.vue?macro=true";
import { default as ajoutlCkRN55ioOKeJzn61si7e1hLXhxB8BFRIVlrpdb6uFoMeta } from "/src/app/pages/mes-evenements/[idEvent]/dates/ajout.vue?macro=true";
import { default as indexpKHSitokxPg6iuFeY_LYxsBqzmhQxCzdCTeRgWyX2FAMeta } from "/src/app/pages/mes-evenements/[idEvent]/dates/index.vue?macro=true";
import { default as _91date_93L8juuxX6iA7SeFwMEPTvZ3AbIoWKz1qjvo4JqZXCukgMeta } from "/src/app/pages/mises-en-avant/[event]/[date].vue?macro=true";
import { default as _91_91date_93_93qm8N8vMsmjDoExT43q8sTPef_O8_bpBUz2K_6DvqYFIMeta } from "/src/app/pages/evenement/[event]/[[date]].vue?macro=true";
import { default as _91_91idDate_93_93PAoikVh5ugxCA5311nHA5QPNFmNUmso_AV0vcffsPpgMeta } from "/src/app/pages/mes-evenements/[idEvent]/[[idDate]].vue?macro=true";
import { default as index4Q_oaCF6D0XTeMnaSUfGT2WeJF_suYqtDvT38M8pDjIMeta } from "/src/app/pages/evenements/[[loc]]/[[period]]/index.vue?macro=true";
import { default as ajoutfA3evaCReH2eLeah48tuESre2GyntjhFcZ_hzzZLGSoMeta } from "/src/app/pages/ajout.vue?macro=true";
import { default as index6UIFUo4l0EjNUT8fEQBKxvVgsUR_PCBIFAMSiqtPzE8Meta } from "/src/app/pages/authentification/index.vue?macro=true";
import { default as cgubg2_vJAFQXPvmv_vT_aaK3sK_fCvzSNvYYlOBtlJyCcMeta } from "/src/app/pages/cgu.vue?macro=true";
import { default as indexp9N4_IK479ZenGyWuPm9pw8jPKIQx5WSruDbREoIGvMMeta } from "/src/app/pages/compte/index.vue?macro=true";
import { default as confidentialitexiW3_6ASoWPHp8OZBU9XM1Vz6J0J_dzeYJVXoCjn27QMeta } from "/src/app/pages/confidentialite.vue?macro=true";
import { default as controlehxs_RMXJtg_GOonRS7VDjsaRF4LDBfNIJ_TyDReOPy4Meta } from "/src/app/pages/controle.vue?macro=true";
import { default as mes_45favorisYImEjy6TXoEVgQxS4Iwr4Xp8_6ld2cQdrCTHbMMoe_UMeta } from "/src/app/pages/mes-favoris.vue?macro=true";
import { default as mes_45recherchesKiDD4LUeSFGBwi3gX0lYWM8crlvRSNrun42q_ZxtPEMMeta } from "/src/app/pages/mes-recherches.vue?macro=true";
import { default as indexcST1GaOUtt_lvSjZYBc0yh_pCuONPvBbaXWnEHOwGuEMeta } from "/src/app/pages/mises-en-avant/index.vue?macro=true";
import { default as sans_45pub6BZ6_kyO_1NG8KoOhgYTbLWQA_eABdH8d2u0424L3XwMeta } from "/src/app/pages/sans-pub.vue?macro=true";
import { default as indexlOQXz4qHz1_tjzzS__aw5L3qkduUse1pUPQ2t0gdaSoMeta } from "/src/app/pages/index.vue?macro=true";
import { default as notificationI1hvucOmE26BpHG_20ZKvwrd5ECdXaQQfUDCDmSj2msMeta } from "~/pages/compte/parametres/notification.vue?macro=true";
import { default as _91uuidOrder_93Xy2YhNDVYlVK2i9_Bpvus74ht1WHTDv4zEs1yvBjbO0Meta } from "~/pages/compte/commandes/[uuidOrder].vue?macro=true";
import { default as mes_45recherchesx4WBo5oI2iJSG56XERYeLnp0_N_Mo0mdLCI6La8B6RkMeta } from "~/pages/mes-recherches.vue?macro=true";
import { default as planningAkfJiDU0GSVs3rIIf5tuWHvfQ_RCG0n8hinV_54yYuUMeta } from "~/pages/mes-evenements/planning.vue?macro=true";
import { default as _91_91idDate_93_93E_jtUAS7kjJ1bHAY4ERjVJs9YF42u2jd85X8TsPBkW8Meta } from "~/pages/mes-evenements/[idEvent]/[[idDate]].vue?macro=true";
import { default as indexHD5IuwOhbt3qkXXIEpA8dA0U2Kfp_65PRd_17AVNZXQMeta } from "~/pages/mes-evenements/[idEvent]/dates/index.vue?macro=true";
import { default as ajoutzyYtay1DwOqn_7ZlRS6lZCIkyCKV_AmYwp_N_b5nY3cMeta } from "~/pages/mes-evenements/[idEvent]/dates/ajout.vue?macro=true";
export default [
  {
    name: "authentification-callback-client-apple",
    path: "/authentification/callback/client/apple",
    meta: appleTUgdupPYETEsFts5sUBdB7DuhgYh5Kp6jsVwYhU5IUYMeta || {},
    component: () => import("/src/app/pages/authentification/callback/client/apple.vue")
  },
  {
    name: "authentification-callback-facebook",
    path: "/authentification/callback/facebook",
    meta: facebookZz0eQjO3HonO2Tm0CxfCbt4TdrXhU2iGsSk6m6fYoXgMeta || {},
    component: () => import("/src/app/pages/authentification/callback/facebook.vue")
  },
  {
    name: "authentification-callback-google",
    path: "/authentification/callback/google",
    meta: googleLMy713whuqFzMMtiJNj_xm0_nOq0Kwpdz23ZncRAD0YMeta || {},
    component: () => import("/src/app/pages/authentification/callback/google.vue")
  },
  {
    name: "compte-messagerie-corbeille",
    path: "/compte/messagerie/corbeille",
    meta: corbeilleqDOpTGeIcKtfZdtuQPPccNTF_avuLepmujmzRAHgbo8Meta || {},
    component: () => import("/src/app/pages/compte/messagerie/corbeille.vue")
  },
  {
    name: "compte-parametres-avatar",
    path: "/compte/parametres/avatar",
    meta: avatarPoGO5IMe5K1Lqrxnf8eS7d3y4L1MTEuKCjRcEPz7LBIMeta || {},
    component: () => import("/src/app/pages/compte/parametres/avatar.vue")
  },
  {
    name: "compte-parametres-connexion",
    path: "/compte/parametres/connexion",
    meta: connexionSlThuxhKy2zWvotEPs_ZQ1YaZdp5p4zzuTt6_hosM9wMeta || {},
    component: () => import("/src/app/pages/compte/parametres/connexion.vue")
  },
  {
    name: "compte-parametres-email",
    path: "/compte/parametres/email",
    meta: emailbAFQJH7XqLZX_DGDoOfIBf_NfafvbvEiDNv4KAnWfkQMeta || {},
    component: () => import("/src/app/pages/compte/parametres/email.vue")
  },
  {
    name: "compte-parametres-mot-de-passe",
    path: "/compte/parametres/mot-de-passe",
    meta: mot_45de_45passeSvv0t73zZhQeBR6fzu_WzPHS9IM7wyhlG6SfLqFjRuQMeta || {},
    component: () => import("/src/app/pages/compte/parametres/mot-de-passe.vue")
  },
  {
    name: "compte-parametres-nom-utilisateur",
    path: "/compte/parametres/nom-utilisateur",
    meta: nom_45utilisateurVLGbCSEncaoXP3lL4hfpGOB6ZoXHNbmyx9930tpmeVgMeta || {},
    component: () => import("/src/app/pages/compte/parametres/nom-utilisateur.vue")
  },
  {
    name: "compte-parametres-notification",
    path: "/compte/parametres/notification",
    meta: notificationGigBvfqLO6izcOLID3YS0zSlnlDc085x0O1gYpz0jaoMeta || {},
    component: () => import("/src/app/pages/compte/parametres/notification.vue")
  },
  {
    name: "compte-parametres-phone",
    path: "/compte/parametres/phone",
    meta: phoneelsAZlNW4DBzI9VSfESuZYsj723JjQgcBHrn_f0AncMMeta || {},
    component: () => import("/src/app/pages/compte/parametres/phone.vue")
  },
  {
    name: "compte-commandes-uuidOrder",
    path: "/compte/commandes/:uuidOrder()",
    meta: _91uuidOrder_93xBqOeeb7ayprc_Ftup4M4UBwMmgrX756LXuh_E572ygMeta || {},
    component: () => import("/src/app/pages/compte/commandes/[uuidOrder].vue")
  },
  {
    name: "compte-messagerie-idTopic",
    path: "/compte/messagerie/:idTopic()",
    meta: _91idTopic_93utjlutkWFk1xon_VyNqO_kmPAWdQk2WO6SCIvzr_23EMeta || {},
    component: () => import("/src/app/pages/compte/messagerie/[idTopic].vue")
  },
  {
    name: "authentification-chargement",
    path: "/authentification/chargement",
    meta: chargementPt5B9ASD36xNeTyjylr37lGQYA5rwPQi_6SWXHTd6MkMeta || {},
    component: () => import("/src/app/pages/authentification/chargement.vue")
  },
  {
    name: "compte-commandes",
    path: "/compte/commandes",
    meta: index0_HPY7LS06aVrMevTTBUit0udSdwLO3iLLXCoBlHe4cMeta || {},
    component: () => import("/src/app/pages/compte/commandes/index.vue")
  },
  {
    name: "compte-messagerie",
    path: "/compte/messagerie",
    meta: index36IqjPZfI_E6VW8S1lvy_WUYOZPT5wl_m_NBfx22TRcMeta || {},
    component: () => import("/src/app/pages/compte/messagerie/index.vue")
  },
  {
    name: "compte-parametres",
    path: "/compte/parametres",
    meta: indexiqr3a13JhNR6O_KZZAeZFXyyJj4gHl3MeMdPlUCRoVUMeta || {},
    component: () => import("/src/app/pages/compte/parametres/index.vue")
  },
  {
    name: "compte-supprimer",
    path: "/compte/supprimer",
    meta: supprimerZ6E7U8G3nCdAyzxWBl7H3JJQ36vUUr9L0M6_TMuu9OcMeta || {},
    component: () => import("/src/app/pages/compte/supprimer.vue")
  },
  {
    name: "mes-evenements-actifs",
    path: "/mes-evenements/actifs",
    meta: actifsGihZ8OH8irkaoTyhgiqaFrPf566Xz2c50PyN6MyHBh8Meta || {},
    component: () => import("/src/app/pages/mes-evenements/actifs.vue")
  },
  {
    name: "mes-evenements-archives",
    path: "/mes-evenements/archives",
    meta: archivesaHy5hpyMA3OyuYtcgNtzXvOB_KAaSH_P3HxfiSCNKtcMeta || {},
    component: () => import("/src/app/pages/mes-evenements/archives.vue")
  },
  {
    name: "mes-evenements-planning",
    path: "/mes-evenements/planning",
    meta: planningNOzjQb_D5xaM9Vt_RtECsPq_pTZEgQK_UZkDYidKJyQMeta || {},
    component: () => import("/src/app/pages/mes-evenements/planning.vue")
  },
  {
    name: "mises-en-avant-a-utiliser",
    path: "/mises-en-avant/a-utiliser",
    meta: a_45utiliserWONaayWYJTa6VkGkybTuJsWFLkfIAtAOymQ8DerD0CUMeta || {},
    component: () => import("/src/app/pages/mises-en-avant/a-utiliser.vue")
  },
  {
    name: "mises-en-avant-en-attente",
    path: "/mises-en-avant/en-attente",
    meta: en_45attenteFhB1rzzvsHK1GCKepLAztC6XYcoN3qJTxRz_7sef5C8Meta || {},
    component: () => import("/src/app/pages/mises-en-avant/en-attente.vue")
  },
  {
    name: "mises-en-avant-pack",
    path: "/mises-en-avant/pack",
    meta: pack0BIEtafZKsi6fx4rc1HupLvN_nulcf7XJHOAf_fkQmEMeta || {},
    component: () => import("/src/app/pages/mises-en-avant/pack.vue")
  },
  {
    name: "mes-evenements-idEvent-dates-ajout",
    path: "/mes-evenements/:idEvent()/dates/ajout",
    meta: ajoutlCkRN55ioOKeJzn61si7e1hLXhxB8BFRIVlrpdb6uFoMeta || {},
    component: () => import("/src/app/pages/mes-evenements/[idEvent]/dates/ajout.vue")
  },
  {
    name: "mes-evenements-idEvent-dates",
    path: "/mes-evenements/:idEvent()/dates",
    meta: indexpKHSitokxPg6iuFeY_LYxsBqzmhQxCzdCTeRgWyX2FAMeta || {},
    component: () => import("/src/app/pages/mes-evenements/[idEvent]/dates/index.vue")
  },
  {
    name: "mises-en-avant-event-date",
    path: "/mises-en-avant/:event()/:date()",
    meta: _91date_93L8juuxX6iA7SeFwMEPTvZ3AbIoWKz1qjvo4JqZXCukgMeta || {},
    component: () => import("/src/app/pages/mises-en-avant/[event]/[date].vue")
  },
  {
    name: "evenement-event-date",
    path: "/evenement/:event()/:date?",
    meta: _91_91date_93_93qm8N8vMsmjDoExT43q8sTPef_O8_bpBUz2K_6DvqYFIMeta || {},
    component: () => import("/src/app/pages/evenement/[event]/[[date]].vue")
  },
  {
    name: "mes-evenements-idEvent-idDate",
    path: "/mes-evenements/:idEvent()/:idDate?",
    meta: _91_91idDate_93_93PAoikVh5ugxCA5311nHA5QPNFmNUmso_AV0vcffsPpgMeta || {},
    component: () => import("/src/app/pages/mes-evenements/[idEvent]/[[idDate]].vue")
  },
  {
    name: "evenements-loc-period",
    path: "/evenements/:loc?/:period?",
    meta: index4Q_oaCF6D0XTeMnaSUfGT2WeJF_suYqtDvT38M8pDjIMeta || {},
    component: () => import("/src/app/pages/evenements/[[loc]]/[[period]]/index.vue")
  },
  {
    name: "ajout",
    path: "/ajout",
    meta: ajoutfA3evaCReH2eLeah48tuESre2GyntjhFcZ_hzzZLGSoMeta || {},
    component: () => import("/src/app/pages/ajout.vue")
  },
  {
    name: "authentification",
    path: "/authentification",
    meta: index6UIFUo4l0EjNUT8fEQBKxvVgsUR_PCBIFAMSiqtPzE8Meta || {},
    component: () => import("/src/app/pages/authentification/index.vue")
  },
  {
    name: "cgu",
    path: "/cgu",
    meta: cgubg2_vJAFQXPvmv_vT_aaK3sK_fCvzSNvYYlOBtlJyCcMeta || {},
    component: () => import("/src/app/pages/cgu.vue")
  },
  {
    name: "compte",
    path: "/compte",
    meta: indexp9N4_IK479ZenGyWuPm9pw8jPKIQx5WSruDbREoIGvMMeta || {},
    component: () => import("/src/app/pages/compte/index.vue")
  },
  {
    name: "confidentialite",
    path: "/confidentialite",
    meta: confidentialitexiW3_6ASoWPHp8OZBU9XM1Vz6J0J_dzeYJVXoCjn27QMeta || {},
    component: () => import("/src/app/pages/confidentialite.vue")
  },
  {
    name: "controle",
    path: "/controle",
    meta: controlehxs_RMXJtg_GOonRS7VDjsaRF4LDBfNIJ_TyDReOPy4Meta || {},
    component: () => import("/src/app/pages/controle.vue")
  },
  {
    name: "mes-favoris",
    path: "/mes-favoris",
    meta: mes_45favorisYImEjy6TXoEVgQxS4Iwr4Xp8_6ld2cQdrCTHbMMoe_UMeta || {},
    component: () => import("/src/app/pages/mes-favoris.vue")
  },
  {
    name: "mes-recherches",
    path: "/mes-recherches",
    meta: mes_45recherchesKiDD4LUeSFGBwi3gX0lYWM8crlvRSNrun42q_ZxtPEMMeta || {},
    component: () => import("/src/app/pages/mes-recherches.vue")
  },
  {
    name: "mises-en-avant",
    path: "/mises-en-avant",
    meta: indexcST1GaOUtt_lvSjZYBc0yh_pCuONPvBbaXWnEHOwGuEMeta || {},
    component: () => import("/src/app/pages/mises-en-avant/index.vue")
  },
  {
    name: "sans-pub",
    path: "/sans-pub",
    meta: sans_45pub6BZ6_kyO_1NG8KoOhgYTbLWQA_eABdH8d2u0424L3XwMeta || {},
    component: () => import("/src/app/pages/sans-pub.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexlOQXz4qHz1_tjzzS__aw5L3qkduUse1pUPQ2t0gdaSoMeta || {},
    component: () => import("/src/app/pages/index.vue")
  },
  {
    name: "compte-notification",
    path: "/compte/notification",
    meta: notificationI1hvucOmE26BpHG_20ZKvwrd5ECdXaQQfUDCDmSj2msMeta || {},
    component: () => import("~/pages/compte/parametres/notification.vue")
  },
  {
    name: "compte-commande-uuidOrder",
    path: "/compte/commande/:uuidOrder",
    meta: _91uuidOrder_93Xy2YhNDVYlVK2i9_Bpvus74ht1WHTDv4zEs1yvBjbO0Meta || {},
    component: () => import("~/pages/compte/commandes/[uuidOrder].vue")
  },
  {
    name: "compte-uuidOrder",
    path: "/compte/:uuidOrder",
    meta: _91uuidOrder_93Xy2YhNDVYlVK2i9_Bpvus74ht1WHTDv4zEs1yvBjbO0Meta || {},
    component: () => import("~/pages/compte/commandes/[uuidOrder].vue")
  },
  {
    name: "compte-notification-mes-recherches",
    path: "/compte/notification/mes-recherches",
    meta: mes_45recherchesx4WBo5oI2iJSG56XERYeLnp0_N_Mo0mdLCI6La8B6RkMeta || {},
    component: () => import("~/pages/mes-recherches.vue")
  },
  {
    name: "compte-parametres-notification-mes-recherches",
    path: "/compte/parametres/notification/mes-recherches",
    meta: mes_45recherchesx4WBo5oI2iJSG56XERYeLnp0_N_Mo0mdLCI6La8B6RkMeta || {},
    component: () => import("~/pages/mes-recherches.vue")
  },
  {
    name: "mes-evenements-planning",
    path: "/mes-evenements",
    meta: planningAkfJiDU0GSVs3rIIf5tuWHvfQ_RCG0n8hinV_54yYuUMeta || {},
    component: () => import("~/pages/mes-evenements/planning.vue")
  },
  {
    name: "mes-evenements-actifs-idEvent-idDate",
    path: "/mes-evenements/actifs/:idEvent/:idDate?",
    meta: _91_91idDate_93_93E_jtUAS7kjJ1bHAY4ERjVJs9YF42u2jd85X8TsPBkW8Meta || {},
    component: () => import("~/pages/mes-evenements/[idEvent]/[[idDate]].vue")
  },
  {
    name: "mes-evenements-dates",
    path: "/mes-evenements/:idEvent/:idDate?/dates",
    meta: indexHD5IuwOhbt3qkXXIEpA8dA0U2Kfp_65PRd_17AVNZXQMeta || {},
    component: () => import("~/pages/mes-evenements/[idEvent]/dates/index.vue")
  },
  {
    name: "mes-evenements-actifs-dates",
    path: "/mes-evenements/actifs/:idEvent/:idDate?/dates",
    meta: indexHD5IuwOhbt3qkXXIEpA8dA0U2Kfp_65PRd_17AVNZXQMeta || {},
    component: () => import("~/pages/mes-evenements/[idEvent]/dates/index.vue")
  },
  {
    name: "mes-evenements-dates-ajout",
    path: "/mes-evenements/:idEvent/:idDate?/dates/ajout",
    meta: ajoutzyYtay1DwOqn_7ZlRS6lZCIkyCKV_AmYwp_N_b5nY3cMeta || {},
    component: () => import("~/pages/mes-evenements/[idEvent]/dates/ajout.vue")
  },
  {
    name: "mes-evenements-actifs-dates-ajout",
    path: "/mes-evenements/actifs/:idEvent/:idDate?/dates/ajout",
    meta: ajoutzyYtay1DwOqn_7ZlRS6lZCIkyCKV_AmYwp_N_b5nY3cMeta || {},
    component: () => import("~/pages/mes-evenements/[idEvent]/dates/ajout.vue")
  }
]